export const getUser = () => {
  const root = window.localStorage.getItem('persist:root');
  if (root && root.length) {
    const parsedRoot = JSON.parse(root);
    return JSON.parse(parsedRoot.user);
  }
  return null;
};
